import {
  ESiteWorkingConditionAcquisitionStatus,
  ESiteWorkingConditionModulationStatus,
} from "@/types/backoffice/dto/site/working-condition/site-working-condition-dto.ts";

const workingConditionLocale = {
  workingCondition: {
    acquisition: "Acquisition",
    modulation: "Modulations",
    deviceDetails: {
      name: "Nom (MyVoltalis): {name}",
      modulatorName: "Nom (Modulateur): {name}",
      linkName: "Nom (Link): {name}",
      techName: "Nom à l'installation: {name}",
      serial: "Numéro de série: {serial}",
      maxPower: "Puissance maximum relevé: {n} watts",
      type: "Type de matériel: {type}",
      roomType: "Type de pièce: {type}",
      appliance: "Appareil: {appliance}",
      power: "Puissance maximum (relevée): {power}",
      update: "MAJ",
      modulator: "Id Modulateur: {modulatorId}",
      linkCsId: "Link Cs Id: {linkCsId}",
    },
    level: {
      low: "Faible",
      normal: "Normale",
      high: "Élevé",
      none: "Aucune",
    },
    acquisitionStatus: {
      [ESiteWorkingConditionAcquisitionStatus.UNKNOWN]: "Inconnue",
      [ESiteWorkingConditionAcquisitionStatus.BAD]: "Mauvaise",
      [ESiteWorkingConditionAcquisitionStatus.MEDIUM]: "Moyenne",
      [ESiteWorkingConditionAcquisitionStatus.GOOD]: "Bonne",
    },
    modulationStatus: {
      [ESiteWorkingConditionModulationStatus.UNKNOWN]: "Inconnue",
      [ESiteWorkingConditionModulationStatus.NONE]: "Aucune",
      [ESiteWorkingConditionModulationStatus.NOT_TESTED]: "Appareil: Conso faible",
      [ESiteWorkingConditionModulationStatus.KO_DETECTED]: "Appareil: Échec de pilotage",
      [ESiteWorkingConditionModulationStatus.SUCCESS]: "Pilotage réussi",
    },
    modulationTableHeaders: {
      name: "Nom de l'appareil (MyVoltalis)",
      status: "Statut Modulation",
      number: "Nombre",
      level: "Niveau",
      lastComm: "Dernière communication",
    },
    acquisitionModulatorTableHeaders: {
      name: "Nom de l'appareil (MyVoltalis)",
      momboxSerialNumber: "Numéro de série pilote",
      momboxPresentOnSite: "Pilote présent sur site ?",
      momboxSiteId: "ID Site pilote",
      acqRate: "Taux d'acquisition",
      lastComm: "Dernière communication",
      ping: "Ping",
    },
    acquisitionMomboxTableHeaders: {
      siteId: "ID Site",
      name: "Nom",
      hwId: "HW ID",
      csId: "CS ID",
      serialNumber: "Numéro de série",
      operator: "Opérateur",
      presentOnSite: "Présent sur site ?",
      lastSync: "Dernière synchronisation",
      softwareVersion: "Version logicielle",
    },
    acquisitionSensorsTableHeaders: {
      name: "Nom de la pièce",
      serial: "Numéro de série",
      installationDate: "Date d'installation",
      lastPoint: "Date de dernière remontée",
    },
    installationTests: {
      headers: {
        testId: "ID du test",
        date: "Date",
        result: "Résultat",
        details: "Détails",
      },
      status: {
        OK: "Ok",
        NOK: "Nok",
        UNKNOWN: "Inconnu",
      },
      loading: "Chargement des tests d’installation",
      empty: "Aucun test d’installation trouvé",
      error: "Impossible de charger les tests d’installation",
      partial: "Certains tests d’installation n’ont pas pu être chargés",
      retry: "Réessayer",
      expand: "Afficher les tests d’installation de {appliance} sur le modulateur {modulator}",
      collapse: "Masquer les tests d’installation de {appliance} sur le modulateur {modulator}",
    },
  },
};

export type WorkingConditionLocale = typeof workingConditionLocale;
export default workingConditionLocale;
